var map = {
	"./i18n.json": 6029,
	"./i18n_da.json": 8917,
	"./i18n_de.json": 6657,
	"./i18n_en-GB.json": 9789,
	"./i18n_en.json": 1445,
	"./i18n_es.json": 5246,
	"./i18n_fr.json": 8214,
	"./i18n_nl.json": 4312,
	"./i18n_sv.json": 4207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5679;